import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-reply",
  "use": "icon-reply-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-reply\"><defs><style type=\"text/css\"></style></defs><path d=\"M341.333333 938.666667v-128H128V170.666667h768v640h-341.333333l-213.333334 128z m-170.666666-170.666667h213.333333v95.146667L542.72 768H853.333333V213.333333H170.666667v554.666667z\" p-id=\"7195\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol